import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from 'lucide-react';
import { OPENFINANCE_THEME } from '../../constants/openFinanceTheme';
interface CMITopBarProps {
  title: string;
  onBack?: () => void;
  showBackButton?: boolean;
}
export function CMITopBar({
  title,
  onBack,
  showBackButton = true
}: CMITopBarProps) {
  return <motion.div initial={{
    opacity: 0,
    y: -10
  }} animate={{
    opacity: 1,
    y: 0
  }} className="bg-white border-b-2 sticky top-0 z-30" style={{
    borderColor: OPENFINANCE_THEME.colors.borderLight
  }} data-id="element-1579">
      <div className="max-w-7xl mx-auto px-4 h-16 flex items-center justify-between" data-id="element-1580">
        {/* Left: Back button or Logo */}
        <div className="flex items-center gap-3" data-id="element-1581">
          {showBackButton && onBack ? <button onClick={onBack} className="p-2 -ml-2 rounded-lg transition-colors hover:bg-gray-100 active:scale-95" aria-label="Go back" data-id="element-1582">
              <ArrowLeftIcon className="w-5 h-5" style={{
            color: OPENFINANCE_THEME.colors.primary500
          }} data-id="element-1583" />
            </button> : <div className="flex items-center gap-2" data-id="element-1584">
              <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{
            background: OPENFINANCE_THEME.gradients.primary
          }} data-id="element-1585">
                <img src="https://cdn.magicpatterns.com/uploads/6ixnVN3mm3sFs3kb5m4Wow/apple-touch-icon.png" alt="VeloX" className="w-6 h-6 object-contain" data-id="element-1586" />
              </div>
              <span className="font-bold text-lg hidden sm:inline" style={{
            color: OPENFINANCE_THEME.colors.primary700,
            fontFamily: OPENFINANCE_THEME.fonts.display
          }} data-id="element-1587">
                VeloX
              </span>
            </div>}

          {/* Page Title */}
          <h1 className="text-base sm:text-lg font-semibold truncate" style={{
          color: OPENFINANCE_THEME.colors.text,
          fontFamily: OPENFINANCE_THEME.fonts.body
        }} data-id="element-1588">
            {title}
          </h1>
        </div>

        {/* Right: Empty for now, could add actions later */}
        <div className="w-8" data-id="element-1589" />
      </div>
    </motion.div>;
}